import { render } from "./CookingTimeModal.vue?vue&type=template&id=4d6599e6&scoped=true"
import script from "./CookingTimeModal.vue?vue&type=script&lang=js"
export * from "./CookingTimeModal.vue?vue&type=script&lang=js"

import "./CookingTimeModal.vue?vue&type=style&index=0&id=4d6599e6&scoped=true&lang=css"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6599e6"]])

export default __exports__